import {$body} from '../utils/environment';
import tap from '../ractive/ractive-events-tap';
import fade from '../ractive/ractive-transitions-fade';

// ==========================================================================
// SearchForm module
// ==========================================================================
import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.$el = options.$el;
        this.words = options.keywords.split(',');
        this.$dom = {};
        this.options = options;

        this.template;
        this.partials;
        this.fetchingTemplate;
        this.ractiveInstance;

        this.onPlaceholder = true;

        this.jqXHR;

        // Cache.
        this.searchedCache = {};
        this.lastSearched = '';

        this.init();
    }

    /**
     * Initialisation.
     *
     * @return {void}
     */
    init() {
        // Get results template.
        this.fetchTemplate();

        this.$dom.field = this.$el.find('.js-search-field');
        this.$dom.input = this.$el.find('.js-search-calltoaction');

        this.initEvents();
        this.initWords();

        if (this.$dom.input.val().length === 0) {
            this.$dom.input.typed({
                strings: this.words,
                typeSpeed: 30,
                backDelay: 1000,
                loop: true
            });
        }

        this.readyToSearch = true;

        this.$el.on('keyup.SearchForm','.js-search-calltoaction',(e)=>this.inputChange(e));
        this.$el.on('submit', 'form', (e) => {
            e.preventDefault();
            let val = this.$dom.input.val();
            this.search(val);
            return false;
        })


    }

    /**
     * Called after template is loaded.
     * Template can be loaded from cache.
     */
    initRactive()
    {
        if (this.ractiveInstance) {
            return this;
        }

        let domList = this.$el.find('.js-search-ractive');
        this.ractiveInstance = new Ractive({
            el         : domList,
            template   : this.template,
            partials   : this.partials,
            events     : {tap},
            transitions: {fade},
            data    : {
                'hasResults': false,
                'results' : []
            }
        });

        this.ractiveInstance.observe( 'results', (newValue, oldValue, keypath) => {
            if (!newValue) {
                return false;
            }
            this.$el.find('ul').scrollTop(0);
            $body.addClass('search-has-results');
            $body.removeClass('is-searching');

            setTimeout(() => {
                window.App.initModules($('.js-search-ractive').get(0));
            }, 1);
        });


    }

    /**
     * When input changed
     * @param  {Event} e    Fired event
     * @return {this}       Chainable.
     */
    inputChange(e){

        let val = this.$dom.input.val();
        this.throttle(() => { this.search(val) }, 500);

        return this;
    }

    /**
     * Triggers the search. Use values from cache
     * if there are. Memory cache.
     *
     * @param  {string} val Keyword / query.
     * @return {this}       Chainable
     */
    search(val){
        if (val == this.lastSearched) {
            return this;
        }

        // Abort previous jqHXR if there was any.
        if (this.jqXHR) {
            this.jqXHR.abort();
        }

        $body.addClass('is-searching');
        $body.removeClass('search-has-results');

        let length = val.length;
        if(this.readyToSearch && length <= 2 ){
            return this;
        }

        if (typeof this.searchedCache[val] !== 'undefined') {
            this.ractiveInstance.set('results', this.searchedCache[val].results);
            this.ractiveInstance.set('hasResults', true);
            this.lastSearched = val;
            return this;
        }


        this.jqXHR = $.get('search', { query : val }, (response) =>{
            this.searchedCache[val] = response;
            this.ractiveInstance.set('results', response.results)
            this.ractiveInstance.set('hasResults', true)
            this.lastSearched = val;
        }).fail((response) => {
            this.ractiveInstance.set('hasResults', false);
            this.ractiveInstance.set('results', false);
            this.lastSearched = val;
        });

        return this;

    }

    /**
     * Initialisation des mots/phrases à afficher.
     *
     * @return {void}
     */
    initWords() {
        for (let i = 0; i < this.words.length; i += 1) {
            this.words[i] = `${this.words[i].charAt(0).toUpperCase()}${this.words[i].substr(1)}`;
        }

        this.words.pop();
        this.words.unshift(this.options.label);
    }

    /**
     * Initialisation des événements.
     *
     * @return {void}
     */
    initEvents() {
        this.onfocusEvent = this.onfocus.bind(this);
        this.$dom.input.on('focus', this.onfocusEvent);
    }

    /**
     * Lorsque le client interagit avec le formulaire
     * on vide le champ et on détruit le `typed`.
     *
     * @return {void}
     */
    onfocus() {
        this.$dom.input.typed('destroy');

        // Remove first val, which is the place holder...
        if (this.onPlaceholder) {
            this.$dom.input.val('');
            this.onPlaceholder = false;
        }
        this.$dom.field.addClass('is-active');
    }


    /**
     * Get the required template for the list.
     * @return {this}      Chainable.
     */
    fetchTemplate() {

        // Template from sessionStorage
        let template = this.fromCache('volleyball_search_template');
        if (template) {
            this.template = template.template;
            this.partials = template.partials;
            this.initRactive();
            return this;
        }

        if (this.fetchingTemplate || this.template) {
            return this;
        }

        this.fetchingTemplate = true;

        $.get('template', {template: 'volleyball/template/partial/site/header/header-search-results'}, (response) => {
            if (response.success) {
                this.template = response.template;
                this.partials = response.partials;
                this.cache('volleyball_search_template', response);
                this.initRactive();
            }
            this.fetchingTemplate = false;
        }, 'json');

        return this;
    }

    /**
     * Cache value in key, sessionStorage.
     * @param  {string} key   Cache key
     * @param  {object} value Values to be cached.
     * @return {[type]}       [description]
     */
    cache(key, value) {
        if (typeof value === 'object') {
            value = JSON.stringify(value)
        }
        sessionStorage[key] = value;
        return this;
    }

    /**
     * Get object from cache.
     * @param  {string} key Cache key.
     * @return {mixed}      Either the object or false.
     */
    fromCache(key) {
        if (typeof sessionStorage === 'undefined') {
            return false;
        }

        let val = sessionStorage[key];
        if (!val) {
            return false;
        }
        return JSON.parse(val);
    }

    /**
     * Déstructeur.
     *
     * @return {void}
     */
    destroy() {
        this.$dom.input.off('focus', this.onfocusEvent);
        this.$el.off('.SearchForm');

        this.words = [];
        this.$dom = {};
        this.onfocusEvent = null;
    }

    throttle(fn, delay) {
        clearTimeout(window.searchFormTimer);
        window.searchFormTimer = setTimeout(() => {
            fn();
        }, delay);
    }
}
